import { FC, useState } from 'react'
import { UpgradePlanModal } from 'src/components/UpgradePlanModal'
import { useGetUserFeaturesQuery } from 'src/reactQuery/useGetUserFeaturesQuery'
import { AdPerformanceDashboard } from './Dashboard'
import { EmptyState } from './EmptyState'
import classes from './adPerformance.module.scss'

export const AdPerformance: FC = () => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  const { data: userFeatures } = useGetUserFeaturesQuery()
  const adsPerformanceEnabled =
    userFeatures?.data?.adsPerformanceEnabled ?? true

  return (
    <>
      {adsPerformanceEnabled && <AdPerformanceDashboard />}
      {!adsPerformanceEnabled && (
        <div className={classes.disabledWrapper}>
          <EmptyState
            onEnableClick={() => setIsUpgradeModalOpen(true)}
            type="disabled"
          />
        </div>
      )}
      <UpgradePlanModal
        isOpen={isUpgradeModalOpen}
        setIsOpen={setIsUpgradeModalOpen}
      />
    </>
  )
}
